import React, { Component } from 'react';

import "./Story.scss"
import readmoreImage from "../../../../assets/images/mobile/arrow.png"

class Story extends Component {
  constructor() {
    super();
    this.articlePush = this.articlePush.bind(this);
    this.state = {
      pin: {
        readmore: {
          background: "#1f2761 url(" + readmoreImage + ") no-repeat"
        }
      }
    }
  }
  articlePush(link) {
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'MyGoal2017',
      'Action': 'Article_Clicked',
      'Label': link
     });
     window.open(link, "_blank");
  }
  render() {
    return (
      <div className="pin">
      <a href="javascript: void(0);" rel="noopener noreferrer" onClick={() => this.articlePush(this.props.story.link)} title="" target="_blank">
        <img src={this.props.story.imageURL} alt="" title="" />
        <div className="desc">
        <span dangerouslySetInnerHTML={{__html: this.props.story.name}}></span>
        <div style={this.state.pin.readmore} className="readmore"></div>
        </div>
        </a>
      </div>
    );
  }
}

export default Story;



// WEBPACK FOOTER //
// ./src/components/Stories/components/Story/Story.js